export default "__VITE_ASSET__d6b02ac0__"